export default "__VITE_ASSET__Doa2EKpr__"